/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A header row like x,y names the axes.`)
};

const es_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila de cabecera como x,y nombra los ejes.`)
};

const de_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kopfzeile wie x,y benennt die Achsen.`)
};

const nl_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een headerrij zoals x,y benoemt de assen.`)
};

const fr_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne d'en-tête comme x,y nomme les axes.`)
};

const it_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga di intestazione come x,y nomina gli assi.`)
};

const pt_br2_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho como x,y nomeia os eixos.`)
};

const pt_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho como x,y nomeia os eixos.`)
};

const ja_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x,yのようなヘッダー行で軸に名前を付けられます。`)
};

const zh_scatter_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如 x,y 这样的表头行用于命名坐标轴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_ex3", locale)
	if (locale === "en") return en_scatter_ex3(inputs)
	if (locale === "es") return es_scatter_ex3(inputs)
	if (locale === "de") return de_scatter_ex3(inputs)
	if (locale === "nl") return nl_scatter_ex3(inputs)
	if (locale === "fr") return fr_scatter_ex3(inputs)
	if (locale === "it") return it_scatter_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_ex3(inputs)
	if (locale === "pt") return pt_scatter_ex3(inputs)
	if (locale === "ja") return ja_scatter_ex3(inputs)
	return zh_scatter_ex3(inputs)
};